<template>
    <div id="newPicking">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart">
            <!-- <p class="headerT">领料信息</p> -->
            <el-form ref="returnForm" :model="returnForm" :inline="true" label-width="80px" :label-position="labelPosition">
                <el-form-item label="申领人:"  prop="pickingName">
                    <el-select v-model="returnForm.pickingName" filterable placeholder="请选择领料人" style="width: 100%;" :filter-method="PinyinMatch" clearable @change="getPicking">
                        <el-option v-for="(item,index) in pickingList"
                            :label="item.name"
                            :value="item.id"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" size="medium" @click="scanInput" style="margin-bottom: 15px;">扫码输入</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                :summary-method="getSummaries"
                show-summary
                style="width: 100%">
                <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="count"
                    width="100"
                    label="申领数量">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="添加序列号" :visible.sync="dislogSerial" :close-on-click-modal="false" width="1200px"  @close="cancelSerial()">
                <el-row>
                    <el-col>
                        <el-form v-if="dislogSerial" ref="materialParams" :model="materialParams">
                            <el-form-item>
                                <el-input ref="inputRef"  clearable style="width:30%;" @input="queryBySerialNumberData" v-model.trim="materialParams.number" :autofocus="dislogSerial" placeholder="请输入或扫描序列号"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="s-list-container">
                            <span style="text-align:left" class="scanTitle">扫描记录</span>
                            <span class="number" style="text-align:right">{{codeList.length}}</span>
                        </div>

                        <el-row style="height: 540px;border:1px solid #EBEEF5">
                            <el-table
                                :data="codeList"
                                :border="false"
                                height="465"
                                :header-cell-style="{'text-align':'center'}"
                                style="width: 100%;">
                                <el-table-column
                                    align="center"
                                    type="index"
                                    width="50"
                                    label="序号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialCode"
                                    label="物料编号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="modelName"
                                    label="型号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialName"
                                    label="物料名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="code"
                                    label="序列号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="50">
                                    <template slot-scope="scope">
                                        <el-button @click.stop="deleteCode(scope.$index, codeList)" type="text" size="small">移除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button type="success" size="small" class="fr" style="margin: 20px;" @click="scanCompelte">扫描完毕</el-button>
                        </el-row>
                    </el-col>
                    <el-col :span="12">
                        <span class="scanTitle">扫描汇总</span>
                        <el-row style="height: 540px;border:1px solid #EBEEF5">
                            <el-table
                                :data="scanTotalList"
                                show-summary
                                :summary-method="getSummaries"
                                :border="false"
                                :header-cell-style="{'text-align':'center'}"
                                style="width: 100%;max-height:540px">
                                <el-table-column
                                    align="center"
                                    type="index"
                                    width="50"
                                    label="序号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialCode"
                                    label="物料编号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="modelName"
                                    label="型号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="materialName"
                                    label="物料名称">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="count"
                                    label="数量">
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button type="success" size="small" @click="addSerialComformBtn()">添加</el-button>
                    <el-button size="small" @click="cancelSerial()">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 查看序列号弹出框 -->
            <el-dialog  class="dialog-content" :visible.sync="dialogTableVisible">
                <el-row
                    class="dialog-code-content"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading">
                    <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
                        <p>{{item}}</p>
                    </el-col>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogTableVisible = false">关闭</el-button>
                </div>
            </el-dialog>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave()">提交</el-button>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave1()">暂存</el-button>
            <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
                {{pageStatus}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                    <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        </el-col>
    </div>
</template>

<script>
  import {hideLoading, showLoading} from "../../components/loading/loading";

    let moment = require("moment");
    import clip from '@/util/clipboard'
    import PinyinMatch from 'pinyin-match'
    import {
        applyEnginnerList,
        queryBySerialNumber,
        pickingAdd,
        pickingSave
    } from "../../api/api";
    export default {
        name: 'newPicking',
        inject: ['reload'],
        components: {
        },
        data () {
            return {
                materialParams:{
                    number:''        //物料序列号字符串
                },
                dislogSerial:false,  //添加序列号弹出框
                checkCodeList:[],
                codeList:[],         //已扫描序列号数组
                scanTotalList:[],     //超出序列号数组
                dialogTableVisible: false, //弹出框
                pageStatus:'离开当前页面',
                saveStatus:'YQR',
                orderId:'',
                labelPosition:'left',
                returnForm:{
                    pickingName:'',
                },
                copy:[],
                pickingList:[],
                returnData: []
            }
        },
        created(){
            this.getApplyEnginnerList()
        },
        methods: {
            //扫码输入
            scanInput(){
                this.dislogSerial = true;
                this.$nextTick(()=>{
                    this.$refs.inputRef.focus()
                })
            },
            PinyinMatch(val){
                if(val && val.length > 1){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.returnForm.pickingName = val;
                    this.pickingList = result;
                }else{
                    this.pickingList = this.copy;
                    this.returnForm.pickingName = "";
                }
            },
            //扫描汇总
            scanCompelte(){
                let arr = [];
                let obj = {};
                if(this.codeList.length > 0){
                    this.codeList.forEach((item,index)=>{
                        let count = 0;
                        let codeTotal = [];
                        let flag = true;
                        this.codeList.forEach((item2,index2)=>{
                            if(item.materialCode === item2.materialCode){
                                count++;
                                codeTotal.push(item2.code)
                            }
                        })
                        arr.forEach((item1,index1)=>{
                            if(item.materialCode === item1.materialCode){
                                flag = false;
                            }
                        })
                        if(flag){
                            arr.push({
                                materialCode:item.materialCode,
                                materialName:item.materialName,
                                materialCoding:item.materialCoding,
                                modelId:item.modelId,
                                modelName:item.modelName,
                                count:count,
                                codeTotal:codeTotal
                            })
                        }
                    })
                    this.scanTotalList = arr
                }else {
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }
            },
            //查询序列号物料信息
            queryBySerialNumberData(val){
                if(val.length == 8){
                    let para = {
                        number:this.materialParams.number,
                        affiliationType:0,
                        status:1,
                        wareType:'LPC'
                    }
                    queryBySerialNumber(para).then(res => {
                        if (res.data.status==100) {
                            if(res.data.results.length > 0){
                                let isHave = false
                                if(this.codeList.length > 0){
                                    this.codeList.forEach((item,index)=>{
                                        if(item.code == res.data.results[0].code){
                                            isHave = true
                                        }
                                    })
                                    if(!isHave){
                                        this.codeList.push(res.data.results[0])
                                    }else{
                                        this.$message({
                                            message: res.data.results[0].code + '已扫描添加至列表',
                                            type: "warning"
                                        });
                                    }
                                }else{
                                    this.codeList.push(res.data.results[0]);
                                }
                            }else{
                                this.$message({
                                    message: '您输入的序列号有误，请重新输入',
                                    type: "warning"
                                });
                            }
                            this.materialParams.number = "";
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            //提交添加序列号
            addSerialComformBtn(){
                if(this.codeList.length == 0){
                    this.$message({
                        message: '您还未开始输入或扫描序列号',
                        type: "warning"
                    });
                }else if(this.scanTotalList.length == 0){
                    this.$confirm('是否已经完成扫描？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.scanCompelte()
                        this.returnData = this.scanTotalList;
                        this.cancelSerial();
                        this.$message({
                            type: 'success',
                            message: '添加成功'
                        });
                    }).catch(() => {

                    });
                }else{
                    this.returnData = this.scanTotalList
                    this.cancelSerial()
                }

            },
            deleteCode(index,rows){
                rows.splice(index, 1);
                this.scanCompelte()
            },
            //取消/关闭添加序列号弹出框
            cancelSerial(){
                this.dislogSerial = false;
                this.scanTotalList = [];
            },
            //金额转化函数
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //获取领料人
            getApplyEnginnerList() {
                let para={}
                applyEnginnerList(para).then(res => {
                    if (res.data.status==100) {
                        this.pickingList = res.data.results;
                        this.copy = Object.assign(this.pickingList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/pickingManage'
                })
            },
            refresh() {
                this.returnForm.pickingName = '';
                this.returnData = [];
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 1 || index === 6) {
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));

                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                if (sums[5] > 0) {
                    sums[7] = this.toThousands2(sums[7]);
                }
                return sums;
            },
            showSerialNumber(index, row) {
                this.dialogTableVisible = true
                this.checkCodeList = Object.assign({}, row).codeTotal
            },
            getPicking(e){
                this.returnForm.pickingName = e;
                this.$forceUpdate();
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
                ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            },
            //提交
            DetermineSave(){
                if(this.returnForm.pickingName == ''){
                    this.$message({
                        message: '请选择领料人',
                        type: "warning"
                    });
                }else if(this.returnData.length == 0){
                    this.$message({
                        message: '请扫码输入序列号添加物料',
                        type: "warning"
                    });
                }else{
                    let pockingDetails = [];
                    let codeSum = 0;
                    this.returnData.forEach((item,index)=>{
                        pockingDetails.push({
                            materialCoding:item.materialCoding,
                            materialCode:item.materialCode,
                            materialName:item.materialName,
                            modelId:item.modelId,
                            modelName:item.modelName,
                            sum:item.count,
                            sn:item.codeTotal.join(','),
                        })
                        codeSum += item.count
                    })
                    let para = {
                        pickingUser:this.returnForm.pickingName,
                        sum:codeSum,
                        status:this.saveStatus,
                        pockingDetails:pockingDetails
                    };
                    showLoading();
                    pickingAdd(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: '提交成功',
                                type: "success"
                            });
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path);
                                this.$router.replace({
                                    path:'/pickingManage'
                                })
                            }
                            this.emptyCodeList();
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            //暂存
            DetermineSave1(){
                if(this.returnForm.pickingName == ''){
                    this.$message({
                        message: '请选择领料人',
                        type: "warning"
                    });
                }else if(this.returnData.length == 0){
                    this.$message({
                        message: '请扫码输入序列号添加物料',
                        type: "warning"
                    });
                }else{
                    let pockingDetails = [];
                    let codeSum = 0;
                    this.returnData.forEach((item,index)=>{
                        pockingDetails.push({
                            materialCoding:item.materialCoding,
                            materialCode:item.materialCode,
                            materialName:item.materialName,
                            modelId:item.modelId,
                            modelName:item.modelName,
                            sum:item.count,
                            sn:item.codeTotal.join(','),
                        })
                        codeSum += item.count
                    })
                    let para = {
                        pickingUser:this.returnForm.pickingName,
                        sum:codeSum,
                        status:'save',
                        pockingDetails:pockingDetails
                    };
                    showLoading();
                    pickingSave(para).then(res => {
                       hideLoading();
                        if (res.data.status==100) {
                            this.$message({
                                message: '提交成功',
                                type: "success"
                            });
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path);
                                this.$router.replace({
                                    path:'/pickingManage'
                                })
                            }
                            this.emptyCodeList();
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            emptyCodeList(){
                this.codeList = [];
                this.returnData = [];
                this.scanTotalList = [];
                this.materialParams.number = "";
                this.returnForm.pickingName = "";
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/pickingManage'
                })
            },
        },
        computed: {
        },
        watch: {

        },
    }
</script>

<style type="text/css" lang="scss" scoped>
    #newPicking{
        font-size: 14px;
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
      .s-list-container{
            display: flex;
            justify-content: space-between;
            align-items: center;
            // position: relative;
            // .number{
            //     position: relative;
            //     right: 0;
            //     top: 50%;
            //     transform: translateY(-50%);
            // }
        }
    .scanTitle{
        display:block;
        margin:10px
    }
    .dialog-content{
        width:900px;
        margin:0 auto;
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }

            }
        }
    }

</style>



// WEBPACK FOOTER //
// newPicking.vue?786f346d